import React, { useState, useEffect } from "react";
import { Table } from "react-bootstrap";
import CustomDatePicker from "../../../../../components/Custom-Datepicker";
import Select from "react-select";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../../constants/layout/store/filterSlice";
import { API_URL } from "../../../../../constants";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { FaSpinner } from "react-icons/fa";
import FileUploaderTne from "../../../../../components/FileUploaderTne";
import * as Yup from "yup";
import moment from "moment";
import {
  GetServiceCaller,
  PostServiceCaller,
  PostFormServiceCaller,
} from "../../../../../services/serviceCaller";
import { Modal, Button } from "react-bootstrap";

const TnE = () => {
  const todayDate = moment().format("DD-MMM-YYYY");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("New TnE"));
  }, []);

  const initialFormData = {
    ProjectID: "",
    FromDate: todayDate,
    ToDate: todayDate,
    AdvanceAmountUSD: 0,
    ExchangeRateUSD: 0,
    AdvanceAmountINR: 0,
    ExchangeRateINR: 1.00,
    AdvanceAmountBASE: 0,
    BalanceAmountBASE: 0,
    ApprovedAmountBASE: 0,
    AdjustAmountBASE: 0,
    IsDeductFromSalary: 0,
    attachFile: "",
    MonthID: 0,
    parenttxn: "",
    reimbursementLines: [],
  };
  const [formData, setFormData] = useState(initialFormData);
  console.log("formData:::", formData);

  const [loading, setLoading] = useState(false);
  const [projectList, setProjectList] = useState([]);
  const [categoryOpt, setCategoryOpt] = useState([]);
  const [descriptionOpt, setDescriptionOpt] = useState([]);
  const [selectedProject, setSelectedProject] = useState(null);
  const [pageLoading, setPageLoading] = useState(true);
  const [rows, setRows] = useState([]);
  const [errors, setErrors] = useState([]);
  const [deductedCheck, setDeductedCheck] = useState(false);
  const [currencySymbol, setCurrencySymbol] = useState("");
  const [projectTXNs, setProjectTXNs] = useState([]);
  const [resumeFile, setResumeFile] = useState([]);
  const [FileName, setFileName] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [formDataToSubmit, setFormDataToSubmit] = useState(null);

  // const handleInputChange = async (rowIndex, field, value) => {
  //   const updatedReimbursementLines = [...formData.reimbursementLines];
  //   updatedReimbursementLines[rowIndex][field] = value;
  //   setFormData({ ...formData, reimbursementLines: updatedReimbursementLines });

  //   const fieldName = `reimbursementLines[${rowIndex}].AmountUSD`;

  //   validateField(field, rowIndex, {
  //     ...formData,
  //     reimbursementLines: updatedReimbursementLines,
  //   });
  // };

  const handleInputChange = async (rowIndex, field, value) => {
    const updatedReimbursementLines = [...formData.reimbursementLines];

    if (field === "Remark") {
      updatedReimbursementLines[rowIndex][field] = value || "";
    } else {
      updatedReimbursementLines[rowIndex][field] =
        value.trim() === "" ? null : parseFloat(value);
    }

    const updatedFormData = {
      ...formData,
      reimbursementLines: updatedReimbursementLines,
    };

    setFormData(updatedFormData);

    // Validate the specific field
    await validateField(field, rowIndex, updatedFormData);
  };

  const fetchTnE = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}payroll/reimbursements/new-TnE`
      );

      // Project Options
      const TnE = response?.data?.data?.projectList;

      const projectOpt = TnE.map((item) => ({
        value: item.value,
        label: item.text,
      }));

      // Statically append "L&D" (ProjectID 1268) to the list if not already returned
      const staticProject = { value: 1268, label: "L&D" };
      if (!projectOpt.some((item) => item.value === staticProject.value)) {
        projectOpt.push(staticProject);
      }

      setProjectList(projectOpt);

      // Category Options
      const categoryList = response?.data?.data?.categoryList;
      const CategoryOptions = categoryList.map((item) => ({
        value: item.value,
        label: item.text,
      }));
      setCategoryOpt(CategoryOptions);
      setPageLoading(false);
    } catch (error) {
      console.error("Error fetching TnE:", error);
    }
  };

  useEffect(() => {
    fetchTnE();
  }, []);

  const fetchDescriptionAPI = async (selectedValue, rowIndex) => {
    try {
      const url = `${API_URL}payroll/reimbursements/get-category-list?CategoryID=${selectedValue.value}`;
      const response = await GetServiceCaller(url);
      const description = response?.data?.data;
      const options = description.map((item) => ({
        value: item.value,
        label: item.text,
      }));

      // Update description options for this specific row
      setDescriptionOpt((prev) => ({
        ...prev,
        [rowIndex]: options, // Store options under the rowIndex key
      }));
    } catch (error) {
      console.error("Error calling API:", error);
    }
  };

  const handleProjectChange = async (selectedOption, name) => {
    setSelectedProject(selectedOption);
    setDeductedCheck(true);
    setFormData({
      ...formData,
      ProjectID: selectedOption ? selectedOption.value : "",
    });
    if (selectedOption) {
      await fetchProjectDetails(selectedOption.value);
    }
    await validateField(name, selectedOption.value);
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  const fetchProjectDetails = async (selectedValue) => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}payroll/reimbursements/project/currency?ProjectID=${selectedValue}`
      );

      if (response.status === 200) {
        const data = response?.data?.data;
        const nonINRCurrencies = data?.filter(
          (item) => item.CurrencySymbol !== "Rs."
        );
        const Symbol = nonINRCurrencies?.map((item) => item.CurrencySymbol);
        setCurrencySymbol(Symbol);

        const projectTXNs = data.map((item) => item.TXNs);
        setProjectTXNs(projectTXNs);

        const advanceAmountINR = data.find(
          (item) => item.CurrencySymbol === "Rs."
        )?.AdvanceAmount;
        const exchangeRateINR = data.find(
          (item) => item.CurrencySymbol === "Rs."
        )?.ExchangeRate || "1.00";

        const exchangeRateUSD = data.find(
          (item) => item.CurrencySymbol !== "Rs."
        )?.ExchangeRate;

        const projectIDs = data.map((item) => item.IDs);

        const advanceAmountUSD =
          data.find((item) => item.CurrencySymbol !== "Rs.")?.AdvanceAmount ||
          "0.00";

        const advanceAmount =
          data.find((item) => item.CurrencySymbol !== "Rs.")?.AdvanceAmount ||
          "0.00";
        // Update the form data state
        setFormData((prevFormData) => ({
          ...prevFormData,
          AdvanceAmountINR: advanceAmountINR || "0.00",
          ExchangeRateINR: exchangeRateINR || "1.00",
          AdvanceAmountUSD: advanceAmountUSD,
          ExchangeRateUSD: exchangeRateUSD || "0.00",
          parenttxn: projectIDs,
        }));
      }
    } catch (error) {
      console.error("Error calling API:", error);
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleDateChange = (date, rowIndex) => {
    const updatedReimbursementLines = [...formData.reimbursementLines];
    updatedReimbursementLines[rowIndex].OnDate = date.target.value;
    const updatedErrors = { ...errors };
    delete updatedErrors[`reimbursementLines[${rowIndex}].OnDate`];

    setFormData({ ...formData, reimbursementLines: updatedReimbursementLines });
    setErrors(updatedErrors);
  };

  const handleSelect1Change = async (value, rowIndex) => {
    setRows(
      rows.map((r, i) => (i === rowIndex ? { ...r, select1: value } : r))
    );

    // Pass rowIndex to fetchDescriptionAPI
    await fetchDescriptionAPI(value, rowIndex);

    const updatedReimbursementLines = [...formData.reimbursementLines];
    updatedReimbursementLines[rowIndex] = {
      ...updatedReimbursementLines[rowIndex],
      CategoryID_168: value.value,
    };
    setFormData({ ...formData, reimbursementLines: updatedReimbursementLines });

    const fieldName = `reimbursementLines[${rowIndex}].CategoryID_168`;
    await validateField(fieldName, {
      reimbursementLines: updatedReimbursementLines,
    });

    setErrors((prevErrors) => ({
      ...prevErrors,
      [fieldName]: "",
    }));
  };

  const handleSelect2Change = async (value, rowIndex) => {
    const updatedReimbursementLines = [...formData.reimbursementLines];
    updatedReimbursementLines[rowIndex] = {
      ...updatedReimbursementLines[rowIndex],
      SubCategoryID_SD168: value.value,
    };

    setFormData({ ...formData, reimbursementLines: updatedReimbursementLines });

    const fieldName = `reimbursementLines[${rowIndex}].SubCategoryID_SD168`;

    // Remove the error for the specific field
    if (errors?.[fieldName]) {
      delete errors[fieldName];
      setErrors({ ...errors });
    }

    await validateField(fieldName, {
      reimbursementLines: updatedReimbursementLines,
    });
  };

  const schema = Yup.object().shape({
    ProjectID: Yup.string().required("Project is required"),
    reimbursementLines: Yup.array().of(
      Yup.object().shape({
        Remark: Yup.string(),
        CategoryID_168: Yup.number()
          .typeError("Category is required")
          .required("Category is required"),
        SubCategoryID_SD168: Yup.number()
          .typeError("Description is required")
          .required("Description is required"),
        // AmountUSD: Yup.number()
        //   .typeError("Amt is required")
        //   .required("Amt is required"),
        // AmountINR: Yup.number()
        //   .typeError("Amt is required")
        //   // .required("Amt is required"),
        OnDate: Yup.date()
          .typeError("Date is required")
          .nullable()
          .required("Date is required"),
      })
    ),
  });
  // const validateField = async (fieldName, index, updatedData) => {
  //   try {
  //     const fieldPath = `reimbursementLines[${index}].${fieldName}`;
  //     await schema.validateAt(fieldPath, updatedData);

  //     setErrors((prevErrors) => ({
  //       ...prevErrors,
  //       reimbursementLines: prevErrors.reimbursementLines?.map((error, idx) =>
  //         idx === index ? { ...error, [fieldName]: "" } : error
  //       ),
  //     }));
  //   } catch (err) {
  //     if (err.path === `reimbursementLines[${index}].${fieldName}`) {
  //       setErrors((prevErrors) => ({
  //         ...prevErrors,
  //         reimbursementLines: prevErrors.reimbursementLines?.map((error, idx) =>
  //           idx === index ? { ...error, [fieldName]: err.message } : error
  //         ),
  //       }));
  //     }
  //   }
  // };

  const validateField = async (fieldName, rowIndex, updatedData) => {
    try {
      const fieldPath = `reimbursementLines[${rowIndex}].${fieldName}`;
      await schema.validateAt(fieldPath, updatedData);

      // Clear validation error for the field
      setErrors((prevErrors) => {
        const newErrors = prevErrors.reimbursementLines
          ? [...prevErrors.reimbursementLines]
          : [];
        newErrors[rowIndex] = { ...newErrors[rowIndex], [fieldName]: "" };
        return { ...prevErrors, reimbursementLines: newErrors };
      });
    } catch (err) {
      if (err.path === `reimbursementLines[${rowIndex}].${fieldName}`) {
        setErrors((prevErrors) => {
          const newErrors = prevErrors.reimbursementLines
            ? [...prevErrors.reimbursementLines]
            : [];
          newErrors[rowIndex] = {
            ...newErrors[rowIndex],
            [fieldName]: err.message,
          };
          return { ...prevErrors, reimbursementLines: newErrors };
        });
      }
    }
  };

  const handleConfirmSubmit = () => {
    setShowModal(false);
    if (formDataToSubmit) {
      submitForm(formDataToSubmit);
    }
  };

  const handleCloseModal = () => setShowModal(false);
  const submitForm = async (updatedFormData) => {
    console.log("updatedFormData:::::", updatedFormData);

    setLoading(true);
    try {
      const response = await PostFormServiceCaller(
        `${API_URL}payroll/reimbursements/new-TnE`,
        updatedFormData,
        "post"
      );

      if (response?.status === 200) {
        setLoading(false);
        toast.success("Data submitted successfully!");
        setFormData({});
        setTimeout(() => {
          navigate("/my-reimbursements/report");
        }, 2000);
      }
    } catch (error) {
      console.error("Unexpected Error:", error);
    }
  };

const handleSubmit = async (e) => {
  e.preventDefault();

  if (!selectedProject) {
    toast.error("Project field is Required.");
    return;
  }

  const updatedLines = formData.reimbursementLines.map((line) => ({
    ...line,
    AmountUSD:
      line.AmountINR && parseFloat(line.AmountINR) > 0
        ? 0
        : line.AmountUSD || "",
    AmountINR:
      line.AmountUSD && parseFloat(line.AmountUSD) > 0
        ? 0
        : line.AmountINR || "",
  }));

    const AdvanceAmountBASE = (
      parseFloat(formData?.AdvanceAmountUSD || 0) *
      parseFloat(formData?.ExchangeRateUSD || 1) +
      parseFloat(formData?.AdvanceAmountINR || 0) *
      parseFloat(formData?.ExchangeRateINR || 1)
    ).toFixed(2);

  const reimbursementAmountUSD = updatedLines.reduce(
    (sum, line) => sum + (parseFloat(line.AmountUSD) || 0),
    0
  );
  const reimbursementAmountINR = updatedLines.reduce(
    (sum, line) => sum + (parseFloat(line.AmountINR) || 0),
    0
  );

  const reimbursementTotal = (
    reimbursementAmountUSD * (parseFloat(formData?.ExchangeRateUSD) || 1) +
    reimbursementAmountINR
  ).toFixed(2);

  const BalanceAmountBASE = (
    parseFloat(AdvanceAmountBASE) - parseFloat(reimbursementTotal)
  ).toFixed(2);

  const updatedFormData = {
    ...formData,
    reimbursementLines: updatedLines,
    AdvanceAmountBASE,
    BalanceAmountBASE,
    IsDeductFromSalary: formData.IsDeductFromSalary ? 1 : 0,
    attachFile: formData.attachFile,
  };

  if (
    !formData?.reimbursementLines ||
    formData.reimbursementLines?.length === 0
  ) {
    toast.error("You must have at least one record.");
    return;
  }

  try {
    await schema.validate(updatedFormData, { abortEarly: false });
    setErrors({});

    // Always set the form data to submit
    setFormDataToSubmit(updatedFormData);
    
    setLoading(true);
    
    if (!updatedFormData.attachFile) {
      // If NO file is attached, show the modal
      setShowModal(true);
    } else {
      // If file IS attached, submit immediately
      await submitForm(updatedFormData);
    }
  } catch (error) {
    setLoading(false);
    if (error.name === "ValidationError") {
      console.error("Validation Error:", error);
      const validationErrors = {};
      error.inner.forEach((err) => {
        validationErrors[err.path] = err.message;
      });
      setErrors(validationErrors);

      Object.keys(validationErrors).forEach((field) => {
        if (field.startsWith("lines")) {
          toast.error(validationErrors[field], { position: "top-right" });
        }
      });
    } else {
      console.error("Unexpected Error:", error);
    }
  }
};

  const handleAddLine = async () => {
    if (!selectedProject) {
      toast.error("Project field is Required.");
      return;
    }

    // Check if at least one row is added
    if (formData.reimbursementLines.length === 0) {
      // Add the first row
      setFormData((prevState) => ({
        ...prevState,
        reimbursementLines: [
          ...prevState.reimbursementLines,
          {
            LineNo: 1,
            OnDate: "",
            CategoryID_168: "",
            SubCategoryID_SD168: "",
            Remark: "",
            AmountUSD: "",
            AmountINR: "",
            ApplicationStatus_123: "",
          },
        ],
      }));
    } else {
      const invalidRow = formData.reimbursementLines.find(
        (row) => !row.OnDate || !row.CategoryID_168 || !row.SubCategoryID_SD168
      );

      if (invalidRow) {
        toast.error(
          "Please fill all required fields in Previous Row before adding a new one."
        );
        return;
      }
      setFormData((prevState) => {
        const nextLineNo = prevState.reimbursementLines.length + 1;
        return {
          ...prevState,
          reimbursementLines: [
            ...prevState.reimbursementLines,
            {
              LineNo: nextLineNo,
              OnDate: "",
              CategoryID_168: "",
              SubCategoryID_SD168: "",
              Remark: "",
              AmountUSD: "",
              AmountINR: "",
              ApplicationStatus_123: "",
            },
          ],
        };
      });
    }
  };

  const handleDeleteRow = (index) => {
    setFormData((prevState) => ({
      ...prevState,
      reimbursementLines: prevState.reimbursementLines.filter(
        (_, rowIndex) => rowIndex !== index
      ),
    }));
  };

  const handleFile = (file) => {
    if (file) {
      // Clear any previous error messages
      // setErrors((prevErrors) => ({
      //   ...prevErrors,
      //   attachFile: "",
      // }));

      // Update form data and resume file state
      setFileName(file.name);
      setFormData((prevState) => ({
        ...prevState,
        attachFile: file,
      }));
      setResumeFile(file);
    } else {
      // Set an error message if file is invalid
      setErrors((prevErrors) => ({
        ...prevErrors,
        attachFile:
          "File size should not exceed 1MB and must be a PDF or Word document.",
      }));
    }
  };

  const AdvanceAmountBASE = (
    parseFloat(formData?.AdvanceAmountUSD || 0) *
    parseFloat(formData?.ExchangeRateUSD || 1) +
    parseFloat(formData?.AdvanceAmountINR || 0) *
    parseFloat(formData?.ExchangeRateINR || 1)
  ).toFixed(2);

  const reimbursementAmountUSD = formData?.reimbursementLines?.reduce(
    (sum, line) => sum + (parseFloat(line.AmountUSD) || 0),
    0
  );
  const reimbursementAmountINR = formData?.reimbursementLines?.reduce(
    (sum, line) => sum + (parseFloat(line.AmountINR) || 0),
    0
  );

  // Calculate the total amount to subtract (in BalanceAmountBASE)
  const reimbursementTotal = (
    reimbursementAmountUSD * (parseFloat(formData?.ExchangeRateUSD) || 1) +
    reimbursementAmountINR
  ).toFixed(2);

  const BalanceAmountBASE = (
    parseFloat(AdvanceAmountBASE) - parseFloat(reimbursementTotal)
  ).toFixed(2);

  if (pageLoading) {
    return (
      <>
        <p class="position-absolute top-50 start-50 translate-middle text-center">
          <FaSpinner class="spinner" />
        </p>
      </>
    );
  } else {
    return (
      <>
        <div className="container-fluid" id="skill_section">
          <div className="container-fluid" id="skill-table-area">
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-3 col-lg-2">
                  <div class="mb-3">
                    <label for="Code" class="form-label">
                      Project<span className="required">*</span>
                    </label>
                    <Select
                      value={selectedProject}
                      options={projectList}
                      name="ProjectID"
                      onChange={(selectedOption, action) =>
                        handleProjectChange(selectedOption, action.name)
                      }
                    />
                    {errors.ProjectID && (
                      <div className="text-danger">{errors.ProjectID}</div>
                    )}
                  </div>
                </div>
                <div className="col-md-3 col-lg-2">
                  <div class="mb-3">
                    <label for="Code" class="form-label">
                      From Date<span className="required">*</span>
                    </label>
                    <CustomDatePicker
                      handleChange={handleChange}
                      value={formData.FromDate}
                      name="FromDate"
                      id="FromDate"
                      className="form-control"
                      placeholderText="DD-MM-YYYY"
                      maxDate={new Date()}
                    />
                  </div>
                </div>
                <div className="col-md-3 col-lg-2">
                  <div class="mb-3">
                    <label for="Code" class="form-label">
                      To Date<span className="required">*</span>
                    </label>
                    <CustomDatePicker
                      handleChange={handleChange}
                      value={formData.ToDate}
                      name="ToDate"
                      id="ToDate"
                      className="form-control"
                      placeholderText="DD-MM-YYYY"
                      maxDate={new Date()}
                    />
                  </div>
                </div>
              </div>
              <hr class="border-2 border-top mt-0 mb-2 border-black" />
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "15px",
                  marginBottom: "10px",
                }}
              >
                {projectTXNs.map((txn, index) => (
                  <div
                    key={index}
                    style={{
                      backgroundColor: "#00C0EF",
                      padding: "2px",
                      borderRadius: "20px",
                      color: "white",
                    }}
                  >
                    <span>
                      <div dangerouslySetInnerHTML={{ __html: txn }} />
                    </span>
                  </div>
                ))}
              </div>
               <div className="table-responsive">
                <Table bordered>
                  <thead id="thcolor" className="text-center">
                    <tr>
                      <td>#</td>
                      <td scope="col" className="col-2">
                        Date<span className="required">*</span>
                      </td>
                      <td scope="col" className="col-2">
                        Category<span className="required">*</span>
                      </td>
                      <td scope="col" className="col-2">
                        Description<span className="required">*</span>
                      </td>
                      <td>Remark</td>
                      <td>
                        Amt.({currencySymbol})<span className="required">*</span>
                      </td>
                      <td>
                        Amt. (&#8377;)<span className="required">*</span>
                      </td>
                      <td>Base Amt. (&#8377;)</td>
                      <td>Action</td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td className="text-end">
                        <b>Advance Amt. :</b>
                      </td>
                      <td>
                        <input
                          type="text"
                          placeholder="0.00 test"
                          disabled
                          className="form-control text-end"
                          name="AdvanceAmountUSD"
                          value={formData?.AdvanceAmountUSD}
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          placeholder="0.00"
                          disabled
                          className="form-control text-end"
                          name="AdvanceAmountINR"
                          value={formData?.AdvanceAmountINR}
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          disabled
                          placeholder="0.00"
                          className="form-control text-end"
                          name="AdvanceAmountBASE"
                          value={AdvanceAmountBASE}
                        />
                      </td>
                    </tr>

                    {formData?.reimbursementLines?.map((line, index) => {
                      const calculatedAmountINR = parseFloat(
                        (line?.AmountUSD || 0) *
                        (parseFloat(formData?.ExchangeRateUSD) || 1)
                      ).toFixed(2);
                      return (
                        <tr key={index}>
                          <td className="text-center">{index + 1}</td>
                          <td>
                            <CustomDatePicker
                              handleChange={(date) =>
                                handleDateChange(date, index)
                              }
                              value={line.OnDate}
                              name="OnDate"
                              id="OnDate"
                              className={`form-control ${errors?.[`reimbursementLines[${index}].OnDate`]
                                  ? "is-invalid"
                                  : ""
                                }`}
                              placeholderText="DD-MM-YYYY"
                              minDate={formData?.FromDate || null}
                              maxDate={new Date(formData?.ToDate) || null}
                            />
                            {errors?.[`reimbursementLines[${index}].OnDate`] && (
                              <span className="error">
                                {errors[`reimbursementLines[${index}].OnDate`]}
                              </span>
                            )}
                          </td>
                          <td>
                            <Select
                              value={categoryOpt.find(
                                (opt) => opt.value === line.CategoryID_168
                              )}
                              options={categoryOpt}
                              onChange={(value) =>
                                handleSelect1Change(
                                  value,
                                  index,
                                  "CategoryID_168"
                                )
                              } menuPlacement="bottom"
                              menuPortalTarget={document.body}
                              styles={{
                                menuPortal: (base) => ({
                                  ...base,
                                  zIndex: 1050,
                                }),
                              }}
                              className={`${errors?.[
                                  `reimbursementLines[${index}].CategoryID_168`
                                ]
                                  ? "is-invalid"
                                  : ""
                                }`}
                              name="CategoryID_168"
                            />
                            {errors?.[
                              `reimbursementLines[${index}].CategoryID_168`
                            ] && (
                                <span className="error">
                                  {
                                    errors[
                                    `reimbursementLines[${index}].CategoryID_168`
                                    ]
                                  }
                                </span>
                              )}
                          </td>
                          <td>
                            <Select
                              value={
                                descriptionOpt[index]?.find(
                                  (opt) => opt.value === line.SubCategoryID_SD168
                                ) || null // Fallback to null if not found
                              }
                              className={`${errors?.[
                                  `reimbursementLines[${index}].SubCategoryID_SD168`
                                ]
                                  ? "is-invalid"
                                  : ""
                                }`} menuPlacement="bottom"
                              menuPortalTarget={document.body}
                              styles={{
                                menuPortal: (base) => ({
                                  ...base,
                                  zIndex: 1050,
                                }),
                              }}
                              name="SubCategoryID_SD168"
                              options={descriptionOpt[index]}
                              onChange={(value) =>
                                handleSelect2Change(value, index)
                              }
                            />
                            {errors?.[
                              `reimbursementLines[${index}].SubCategoryID_SD168`
                            ] && (
                                <span className="error">
                                  {
                                    errors[
                                    `reimbursementLines[${index}].SubCategoryID_SD168`
                                    ]
                                  }
                                </span>
                              )}
                          </td>
                          <td>
                            <input
                              type="text"
                              placeholder="Remark"
                              className="form-control text-end"
                              value={line.Remark}
                              onChange={(e) =>
                                handleInputChange(index, "Remark", e.target.value)
                              }
                            />
                          </td>
                          <td>
                            <input
                              type="number"
                              placeholder="0.00"
                              className={`form-control text-end ${errors?.[`reimbursementLines[${index}].AmountUSD`]
                                  ? "is-invalid"
                                  : ""
                                }`}
                              value={line?.AmountUSD}
                              disabled={
                                (line?.AmountINR &&
                                  parseFloat(line?.AmountINR) > 0) ||
                                (formData?.AdvanceAmountUSD === "0.00" &&
                                  !line?.AmountUSD)
                              }
                              onChange={(e) =>
                                handleInputChange(
                                  index,
                                  "AmountUSD",
                                  e.target.value
                                )
                              }
                            />
                            {errors[`reimbursementLines[${index}].AmountUSD`] && (
                              <span className="error">
                                {errors[`reimbursementLines[${index}].AmountUSD`]}
                              </span>
                            )}
                          </td>
                          <td>
                            <input
                              type="number"
                              placeholder="0.00"
                              className={`form-control text-end ${errors?.[`reimbursementLines[${index}].AmountINR`]
                                  ? "is-invalid"
                                  : ""
                                }`}
                              value={line?.AmountINR}
                              disabled={
                                line?.AmountUSD && parseFloat(line?.AmountUSD) > 0
                              }
                              name="AmountINR"
                              onChange={(e) =>
                                handleInputChange(
                                  index,
                                  "AmountINR",
                                  e.target.value
                                )
                              }
                            />
                            {errors[`reimbursementLines[${index}].AmountINR`] && (
                              <span className="error">
                                {errors[`reimbursementLines[${index}].AmountINR`]}
                              </span>
                            )}
                          </td>
                          <td>
                            <input
                              type="text"
                              placeholder="0.00"
                              className="form-control text-end"
                              value={
                                calculatedAmountINR != 0.0
                                  ? calculatedAmountINR
                                  : line.AmountINR
                              }
                              disabled
                            />
                          </td>
                          <td>
                            <div
                              type="button"
                              onClick={() => handleDeleteRow(index)}
                              className="text-center"
                            >
                              <i
                                className="bi bi-trash"
                                style={{ fontSize: "1.2rem" }}
                              ></i>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                    <tr>
                      <td>
                        <button
                          className="custom-btn"
                          onClick={(e) => {
                            e.preventDefault();
                            handleAddLine();
                          }}
                        >
                          <i className="bi bi-plus-lg"></i>Add
                        </button>
                      </td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td className="text-end">
                        <b>Total:</b>
                      </td>
                      <td className="text-end">
                        <div>
                          <b>
                            {Array.isArray(formData?.reimbursementLines)
                              ? formData?.reimbursementLines
                                .reduce(
                                  (sum, line) =>
                                    sum + (parseFloat(line?.AmountUSD) || 0),
                                  0
                                )
                                .toFixed(2)
                              : "0.00"}
                          </b>
                        </div>
                        <div>
                          <p>(ER:{formData?.ExchangeRateUSD})</p>
                        </div>
                      </td>
                      <td className="text-end">
                        <div>
                          <b>
                            {Array.isArray(formData?.reimbursementLines)
                              ? formData?.reimbursementLines
                                .reduce(
                                  (sum, line) =>
                                    sum + (parseFloat(line?.AmountINR) || 0),
                                  0
                                )
                                .toFixed(2)
                              : "0.00"}
                          </b>
                        </div>
                        <div>
                          <p>
                            {/* (ER:
                          {parseFloat(formData?.ExchangeRateINR || 1).toFixed(
                            2
                          )}
                          ) */}
                            (ER:1.00)
                          </p>
                        </div>
                      </td>
                      <td className="text-end">
                        <div>
                          <b>
                            {(
                              formData?.reimbursementLines?.reduce(
                                (sum, line) =>
                                  sum + (parseFloat(line.AmountUSD) || 0),
                                0
                              ) *
                              (parseFloat(formData?.ExchangeRateUSD) || 1) +
                              formData?.reimbursementLines?.reduce(
                                (sum, line) =>
                                  sum + (parseFloat(line.AmountINR) || 0),
                                0
                              )
                            ).toFixed(2)}
                          </b>
                        </div>
                        <div>
                          <p>(ER:1.00)</p>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="3" rowspan="3">
                        <div className="col-md-12">
                          <FileUploaderTne handleFile={handleFile} />
                          <div className="mb-0">
                            {FileName ? <p className="mb-0">{FileName}</p> : null}
                          </div>
                          {/* {errors?.attachFile && (
                          <div className="error">{errors?.attachFile}</div>
                        )} */}
                          <span className="attach_msg">
                            Please upload a PDF that includes all the receipts.
                          </span>
                        </div>
                      </td>
                      <td>
                        {" "}
                        {deductedCheck && BalanceAmountBASE >= 0 && (
                          <div className="d-flex gap-1 mt-2">
                            <div>
                              <input
                                className="form-check-input"
                                type="checkbox"
                                name="IsDeductFromSalary"
                                checked={formData.IsDeductFromSalary === 1}
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    IsDeductFromSalary: e.target.checked ? 1 : 0,
                                  })
                                }
                              />
                            </div>
                            <label className="col-sm-12">
                              <b>Deduct From Salary</b>
                            </label>
                          </div>
                        )}
                      </td>
                      <td></td>
                      <td colspan="3" rowspan="2">
                        <div className="row">
                          <label className="col-sm-5 mt-2">
                            <b>
                              Balance Amt. (&#8377;)
                              <span className="required">*</span>
                            </b>
                          </label>
                          <div className="col-sm-7">
                            <input
                              type="text"
                              className="form-control text-end"
                              disabled
                              placeholder="0.00"
                              name="BalanceAmountBASE"
                              value={BalanceAmountBASE}
                            />
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </Table>
                </div>
              <div className="text-end">
                <button type="submit" className="custom-btn">
                  {loading ? <FaSpinner class="sm-spinner" /> : "Submit"}
                </button>
              </div>
            </form>
          </div>
               {showModal && (
          <div
            className="modal"
            tabIndex="-1"
            role="dialog"
            style={{
              display: "block",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
            }}
          >
            <div
              className="modal-dialog modal-dialog-centered modal-md"
              role="document"
            >
              <div className="modal-content">
                <div
                  className="modal-header"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    borderBottom: "1px solid #f0f0f0",
                    backgroundColor: "#f8f9fa",
                    borderRadius: "8px 8px 0 0",
                  }}
                >
                  <p
                    style={{
                      fontSize: "16px",
                      fontWeight: "600",
                      color: "#27568B",
                      margin: "0",
                    }}
                  >
                    Submit TnE Form Without Attachment?
                  </p>
                  <span className="me-2">
                    <i className="bi bi-x-lg" onClick={handleCloseModal}></i>
                  </span>
                </div>
                <div className="modal-body">
                  Are you sure you want to submit the form without an
                  attachment?
                  <div className="text-end mt-4">
                    <button
                      className="cancel-btn-sm me-2"
                      onClick={handleCloseModal}
                    >
                      No
                    </button>
                    <button
                      className="custom-btn-sm"
                      onClick={handleConfirmSubmit}
                    >
                      Yes
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        </div>
      </>
    );
  }
};

export default TnE;
